import React from 'react';
import { Layout } from 'antd';
import Mscratch from '../../services/mscratch';
import ProjectService from '../../services/api/project';
import projectModel from '../../model/project.model';
import DragHolder from '../dragholder/dragholder';
import LoadingWeb from './loading.web';
import Emitter from '../../services/emitter';
import { connect } from 'react-redux';
import './mscratch.less';
import { isWeb } from '../../util/env';

class MScratch extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        (async () => {
            let initProjectData = await ProjectService.loadRemoteProjectFromUrl();
            let exts = await Mscratch.inject('mscratchContainer', initProjectData);
            Emitter.emit('ExtsFound', exts);
            if(isWeb()) {
                if(initProjectData) {
                    Emitter.emit('UpdateProjectFromUrl');
                } else {
                    projectModel.createNewProject();
                }
            }
        })();
    }

    shouldComponentUpdate(nextProps) {
        return this.props.project.showLoadingPage !== nextProps.project.showLoadingPage;
    }

    render() {
        const show = this.props.project.showLoadingPage;
        return (
            <Layout className="mscratch-container-box">
                <DragHolder />
                {show ? <LoadingWeb /> : null}
                <div id="mscratchContainer" className="mscratch-container"></div>
            </Layout>
        );
    }
}


const mapStateToProps = state => ({
    project: state.project
});

export default connect(
    mapStateToProps
)(MScratch);